export enum AttributeColumnType {
  Title = "title",
  Value = "value",
  Unit = "unit"
}